import ConfirmModal from "../../../components/ConfirmModal";
import {useDispatch, useSelector} from "react-redux";
import {setManageBlogModals, tryDeleteBlogTag} from "../../../redux/slices/manageBlogSlice";

const ManageTagsConfirmModal = () => {

  const dispatch = useDispatch();
  const { modal, data} = useSelector((state => state.manageBlogs.modals.confirm));
  const {
    loading: editing
  } = useSelector((state) => state.dynamicElements.editing);


  const onConfirm = () => {

    dispatch(tryDeleteBlogTag());

  };


  return (
    <ConfirmModal
      title="Remove this tag?"
      showModal={modal}
      setShowModal={() => dispatch(setManageBlogModals())}
      disabled={editing}
      buttonLabel="Ok"
      onConfirm={onConfirm}
    >


      <div>
        Remove this tag "<strong>{data?.delete.title ?? ""}</strong>" permanently?
        <div className="text-sm mt-1"><strong>Note:</strong> You won't be able to delete the tag if it is associated with a blog.</div>
      </div>


    </ConfirmModal>
  );
};

export default ManageTagsConfirmModal;
